<template>
  <button type="button" class="btn btn-dark" v-on:click="$gAuth.signOut">Logout</button>
</template>

<script>
export default {};
</script>